import { Theme, alpha } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import {
  MIDDLE_MARGIN,
  LARGE_MARGIN,
  SMALL_MARGIN,
  BIG_MARGIN,
  colorsPalette,
  SUBMIDDLE_MARGIN,
  TINY_MARGIN,
} from '../../theme';
import { Background } from '../../types';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        background: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: LARGE_MARGIN,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
      },
      container: {
        maxWidth: 832,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      heading: {
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: MIDDLE_MARGIN,
        },
      },
      description: {
        marginBottom: MIDDLE_MARGIN,
      },
      title: {
        marginBottom: SUBMIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: BIG_MARGIN,
        },
      },
      cardsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          alignItems: 'stretch',
          width: `calc(100% + ${BIG_MARGIN}px)`,
          marginLeft: BIG_MARGIN / 2,
          marginRight: BIG_MARGIN / 2,
          marginBottom: `-${BIG_MARGIN / 2}px`,
        },
      },
      cardWrapper: {
        maxWidth: 320,
        width: '100%',
        position: 'relative',
        marginBottom: SUBMIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          flexGrow: 0,
          flexBasis: '33.33%',
          maxWidth: '33.33%',
          padding: BIG_MARGIN / 2,
          paddingTop: 0,
          marginBottom: 0,
        },
        '&:last-child': {
          marginBottom: 0,
        },
      },
      card: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
          height: '100%',
        },
      },
    }),
  );

export const useCardStyles = (background, minHeight, hasHoverEffect) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        position: 'relative',
        perspective: 1000,
        display: 'flex',
        ...(hasHoverEffect && {
          cursor: 'pointer',
          '&:hover': {
            '& $frontTile': {
              visibility: 'hidden',
              transform: 'rotateY(180deg)',
            },
            '& $backTile': {
              visibility: 'visible',
              transform: 'translateY(-50%) rotateY(0deg)',
            },
          },
        }),
        '&$toggled': {
          '& $frontTile': {
            visibility: 'hidden',
            transform: 'rotateY(180deg)',
          },
          '& $backTile': {
            visibility: 'visible',
            transform: 'translateY(-50%) rotateY(0deg)',
          },
        },
      },
      toggled: {},
      tile: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        transition: 'ease-in-out 800ms',
        transitionDelay: '250ms',
        transformStyle: 'preserve-3d',
        boxShadow: `0px 3px 6px ${alpha(colorsPalette.black, 0.4)}`,
        borderRadius: 8,
        backfaceVisibility: 'hidden',
        width: '100%',
      },
      frontTile: {
        alignItems: 'center',
        padding: `${MIDDLE_MARGIN}px ${SUBMIDDLE_MARGIN}px`,
        background: colorsPalette.blackSecondary,
        ...(minHeight && { minHeight }),
        [theme.breakpoints.up('sm')]: {
          background:
            background === Background.Dark ? colorsPalette.blackSecondary : colorsPalette.blueDark,
        },
        [theme.breakpoints.up('md')]: {
          padding: SUBMIDDLE_MARGIN,
        },
      },
      backTile: {
        background: colorsPalette.violetAnalyticsCard,
        visibility: 'hidden',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%) rotateY(-180deg)',
        left: 0,
        minHeight: '100%',
      },
      backTileContent: {
        padding: `${MIDDLE_MARGIN}px ${SUBMIDDLE_MARGIN}px`,
        [theme.breakpoints.up('md')]: {
          padding: SUBMIDDLE_MARGIN,
        },
      },
      bigImg: {
        width: 72,
        height: 72,
        marginBottom: SUBMIDDLE_MARGIN,
      },
      img: {
        width: 36,
        height: 36,
        marginBottom: TINY_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: SMALL_MARGIN,
        },
      },
    }),
  );

export default useStyles;
